<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="ProductName">
          <a-input placeholder="ProductName" v-decorator="['productName', validatorRules.productName]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="ProductType">
          <a-select showSearch v-decorator="['appSsid', validatorRules.appSsid]">
            <a-select-option v-for="item in appList" :key="item.appssid">
              {{ item.appName }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Pre/Post Disbursement Receipt">
          <a-select v-decorator="['receiptTimeFlag', validatorRules.receiptTimeFlag]">
            <a-select-option :key="'0'">Pre-collection</a-select-option>
            <a-select-option :key="'1'">Post-collection</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Status">
          <a-select v-decorator="['status', validatorRules.status]">
            <a-select-option :key="'0'">Expired</a-select-option>
            <a-select-option :key="'1'">Valid</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addProduct, editProduct } from '@/webpublicapi/operation'
import { getApplist } from '@/webpublicapi/order'

export default {
  name: 'DictModal',

  data() {
    return {
      value: 1,
      title: 'Action',
      googleFlag: '0',
      allowPrepay: 1,
      productId: '',
      visibleCheck: true,
      visible: false,
      model: {},
      appList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        productName: { rules: [{ required: true, message: 'Please enterProductName' }] },
        receiptTimeFlag: { rules: [{ required: true, message: 'Please select pre/post disbursement receipt' }] },
        status: { rules: [{ required: true, message: 'Please select status' }] },
        appSsid: { rules: [{ required: true, message: 'Please selectProductType' }] },
      },
    }
  },
  created() {},
  methods: {
    add(params) {
      console.log('---------------->' + params.googleFlag)
      this.edit({ googleFlag: params.googleFlag })
    },
    edit(record) {
      this.googleFlag = record.googleFlag
      getApplist().then((res) => {
        this.appList = res.data || []
      })
      this.form.resetFields()
      this.model = Object.assign({}, record)
      if (record.id) {
        this.allowPrepay = record.allowPrepay
        this.visibleCheck = record.allowPrepay == 1
      }
      this.visible = true
      const data = pick(this.model, 'productName', 'appSsid', 'receiptTimeFlag', 'status')
      data.allowPrepay = !!data.allowPrepay
      this.$nextTick(() => {
        this.form.setFieldsValue(data)
      })
    },
    onChose(checked) {
      if (checked) {
        this.allowPrepay = 1
        this.visibleCheck = true
      } else {
        this.allowPrepay = 0
        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk() {
      console.log('----------------->' + this.googleFlag)
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          formData.allowPrepay = +formData.allowPrepay ? 1 : 0
          formData.googleFlag = that.googleFlag
          console.log('----------------->' + that.googleFlag)
          let obj
          if (!that.model.id) {
            formData.productId = this.productId
            obj = addProduct(formData)
          } else {
            obj = editProduct(formData)
          }
          obj
            .then((res) => {
              if (res.code === 1000) {
                that.$message.success(res.msg)
                that.$emit('ok')
              } else {
                that.$message.warning(res.msg)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    // Close
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>
